"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/HKFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_100)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_100`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M-6 -0.857178H30V24.8571H-6V-0.857178Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M-6 -0.857178H30V24.8571H-6V-0.857178Z",
					fill: "#EE1C25"
				}),
				/* @__PURE__ */ n("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M14.5714 11.4685C13.2034 10.6114 12.8571 12.1697 12.8571 11.4685C12.8571 10.0491 14.3914 8.8971 16.2857 8.8971C18.18 8.8971 19.7143 10.0491 19.7143 11.4685C18.0874 11.4685 17.9246 12.3257 17.1428 12.3257C16.1828 12.3257 15.9394 12.3257 14.5714 11.4685ZM16.7143 11.1428C16.8279 11.1428 16.9369 11.0977 17.0173 11.0173C17.0977 10.9369 17.1428 10.8279 17.1428 10.7142C17.1428 10.6006 17.0977 10.4916 17.0173 10.4112C16.9369 10.3308 16.8279 10.2857 16.7143 10.2857C16.6006 10.2857 16.4916 10.3308 16.4112 10.4112C16.3309 10.4916 16.2857 10.6006 16.2857 10.7142C16.2857 10.8279 16.3309 10.9369 16.4112 11.0173C16.4916 11.0977 16.6006 11.1428 16.7143 11.1428ZM13.6114 14.5062C14.0023 12.9411 12.4148 13.0937 13.08 12.8777C14.4308 12.4371 15.9994 13.5411 16.5857 15.3428C17.1703 17.1428 16.5497 18.96 15.1988 19.3988C14.6966 17.8508 13.8308 17.9622 13.5891 17.2182C13.2926 16.3045 13.2188 16.0731 13.6114 14.5062ZM14.5817 16.4434C14.599 16.497 14.6268 16.5466 14.6633 16.5895C14.6998 16.6323 14.7444 16.6676 14.7945 16.6932C14.8447 16.7189 14.8994 16.7344 14.9555 16.7388C15.0117 16.7433 15.0681 16.7367 15.1217 16.7194C15.1753 16.7021 15.2249 16.6743 15.2678 16.6378C15.3107 16.6013 15.3459 16.5567 15.3715 16.5065C15.3972 16.4564 15.4127 16.4017 15.4172 16.3456C15.4216 16.2894 15.415 16.233 15.3977 16.1794C15.3627 16.0712 15.2861 15.9813 15.1849 15.9295C15.0836 15.8778 14.9659 15.8684 14.8577 15.9034C14.7495 15.9384 14.6596 16.015 14.6079 16.1162C14.5561 16.2175 14.5467 16.3352 14.5817 16.4434ZM10.4228 14.532C12.0343 14.4205 11.4 12.9565 11.8114 13.524C12.6446 14.6725 12.0806 16.5068 10.548 17.6194C9.01542 18.7337 7.09713 18.7028 6.26227 17.5542C7.57884 16.5977 7.20513 15.8091 7.83942 15.3497C8.61599 14.784 8.81313 14.6417 10.4228 14.532ZM8.8817 16.0542C8.83611 16.0873 8.79749 16.1291 8.76804 16.1771C8.73859 16.2251 8.71888 16.2785 8.71004 16.3341C8.70121 16.3897 8.70342 16.4466 8.71655 16.5014C8.72968 16.5561 8.75347 16.6078 8.78656 16.6534C8.81965 16.699 8.8614 16.7376 8.90942 16.7671C8.95744 16.7965 9.01079 16.8162 9.06643 16.825C9.12206 16.8339 9.17889 16.8317 9.23367 16.8185C9.28846 16.8054 9.34012 16.7816 9.3857 16.7485C9.47777 16.6817 9.53952 16.581 9.55736 16.4687C9.5752 16.3563 9.54768 16.2415 9.48085 16.1494C9.41401 16.0573 9.31334 15.9956 9.20098 15.9777C9.08862 15.9599 8.97377 15.9874 8.8817 16.0542ZM9.41656 11.508C10.0183 13.0062 11.2148 11.9502 10.8034 12.516C9.96856 13.6645 8.05027 13.6937 6.5177 12.5811C4.98513 11.4668 4.42113 9.63424 5.25599 8.48396C6.57084 9.44224 7.20684 8.84396 7.83942 9.30339C8.61599 9.8691 8.81313 10.0114 9.41656 11.508ZM7.4897 10.5137C7.44454 10.4765 7.39225 10.449 7.33606 10.4328C7.27986 10.4166 7.22093 10.412 7.16292 10.4195C7.1049 10.4269 7.04902 10.4461 6.99872 10.476C6.94841 10.5058 6.90475 10.5456 6.87041 10.593C6.83607 10.6403 6.81178 10.6942 6.79905 10.7513C6.78632 10.8083 6.7854 10.8674 6.79636 10.9249C6.80733 10.9823 6.82993 11.0369 6.86279 11.0853C6.89564 11.1337 6.93806 11.1749 6.98742 11.2062C7.07951 11.2648 7.19047 11.286 7.29766 11.2655C7.40485 11.2451 7.50021 11.1845 7.56428 11.0962C7.62835 11.0078 7.6563 10.8984 7.64244 10.7901C7.62859 10.6819 7.57396 10.583 7.4897 10.5137ZM11.9794 9.61539C10.7417 10.6525 12.1166 11.4634 11.4497 11.2457C10.0988 10.8068 9.47827 8.99139 10.0628 7.19139C10.6491 5.39139 12.2177 4.28567 13.5686 4.72453C13.0663 6.27253 13.8308 6.69082 13.5891 7.43482C13.2926 8.34853 13.2171 8.57996 11.9794 9.61539ZM12.3308 7.47767C12.3508 7.42359 12.3596 7.36605 12.3567 7.30849C12.3539 7.25093 12.3395 7.19453 12.3143 7.14267C12.2892 7.09081 12.2539 7.04455 12.2105 7.00666C12.167 6.96877 12.1164 6.94002 12.0616 6.92214C12.0068 6.90427 11.949 6.89762 11.8916 6.90261C11.8342 6.90759 11.7784 6.92411 11.7275 6.95116C11.6766 6.97822 11.6317 7.01526 11.5954 7.06007C11.5592 7.10488 11.5324 7.15654 11.5166 7.21196C11.4861 7.31859 11.4982 7.43286 11.5503 7.53077C11.6023 7.62868 11.6903 7.7026 11.7957 7.737C11.9011 7.7714 12.0158 7.7636 12.1156 7.71524C12.2154 7.66688 12.2925 7.58173 12.3308 7.47767Z",
					fill: "white"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_100`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as HKFlag };
